import React from "react"

const Footer = () => {
  return (
    <section className="black-background">
      <div className="footer-container">
        <div style={{ marginLeft: "auto", marginRight: "10px" }}>
          <footer>
            <a className="footer-text" href="">
              Privacy Policy
            </a>
            <span className="footer-text">Copyright © Click4Fit</span>
          </footer>
        </div>
      </div>
    </section>
  )
}

export default Footer
